// export constants
export const CC_TYPE_CA = 'CA';
export const CC_TYPE_VI = 'VI';
export const MAX_TRIES_CC = 40;
export const MS_INTERVAL_VERY_FAST = 60;
export const MS_INTERVAL_HALF_SECOND = 500;
export const MS_INTERVAL_FULL_SECOND = 1000;
export const WAIT_COUNTER_LIMIT = 60;
export const K_ID = 'id';

// cookies
export const COOKIE_NAME_PM_TXN = 'up_pmt';
export const COOKIE_TRAVELER_DETAILS = 'up_td';
export const COOKIE_NAME_PERSIST = 'up_br';
export const COOKIE_NAME_ORDER_ID = 'up_pmo';
export const COOKIE_NAME_CONFIRMATION_ID = 'up_pmc';

// BUILD types
export const BUILD_DEVELOP = 'develop';
export const BUILD_DEVELOP_HTTPS = 'develop-s';
export const BUILD_STAGING = 'staging';
export const BUILD_PRODUCTION = 'production';
export const BUILD_AGENT = 'agent';

// ECs
export const EC_SYS = 'sys';
export const EC_USER = 'user';

// EAs
export const EA_POST = 'post';
export const EA_POST_RESULT = 'post-result';
export const EA_CHECK = 'check';
export const EA_GET = 'get';
export const EA_LOAD = 'load';
export const EA_LAUNCH = 'launch';
export const EA_ENABLE = 'enable';
export const EA_DISABLE = 'disable';
export const EA_SELECT = 'select';
export const EA_MOUSEUP = 'mouseup';
export const EA_SHOW = 'show';
export const EA_ERROR = 'error';
export const EA_TRACK = 'track';
export const EA_INIT = 'init';
export const EA_CART = 'cart';
export const EA_REPLACE = 'replace';
export const EA_HOLD = 'hold';

// ELs
export const EL_PREREQS = 'prereqs';
export const EL_PAY_MONTHLY = 'Pay Monthly';
export const EL_PAY_IN_FULL = 'Pay in Full';
export const EL_UPLIFT_PAYMENTS = 'UpLift.Payments';
export const EL_MWEB = 'mweb';
export const EL_PAYMENT = 'payment';
export const EL_MODAL = 'modal';
export const EL_PAGE = 'page';
export const EL_BOOKING = 'booking';
export const EL_ORDER_INFO = 'order-info';
export const EL_FROM_PRICES = 'from-prices';
export const EL_ORDER_CREATE = 'order-create';
export const EL_ORDER_UPDATE = 'order-update';
export const EL_CARD = 'card';
export const EL_CONTAINER = 'container';
export const EL_HOTEL = 'hotel';
export const EL_SEARCH = 'search';
export const EL_COMPLETE = 'complete';
export const EL_CID = 'cid';
export const EL_ROOM_UPGRADE = 'room-upgrade';
export const EL_PLACE_ORDER = 'place-order';
export const EL_CHECKOUT = 'checkout';

// EVs
export const EV_RESULT = 'result';
export const EV_MSG = 'msg';
export const EV_ORDER_ID = 'order_' + K_ID;
export const EV_BUILD = 'build';
export const EV_ORIGIN = 'origin';
export const EV_ORDER_AMOUNT = 'order_amount';
export const EV_STATUS = 'status';
export const EV_SOURCE = 'source';
export const EV_FROM = 'from';
export const EV_PAGE = 'page';
export const EV_TOTAL = 'from';
export const EV_REASON = 'reason';
export const EV_VALUE = 'value';
export const EV_VERSION = 'version';
export const EV_MERCHANT = 'merchant';
export const EV_MESSAGE = 'message';
export const EV_RAW = 'raw';

// Results
export const R_OUT_OF_FILTER = 'out_of_filter';
export const R_SHOW_IFRAME = 'show_iframe';
export const REASON_OUT_OF_FILTER = 'out of filter';
export const R_MCODE = 'mcode';
export const MCODE_OUT_OF_FILTER = 2;

// Messages and error info
export const MSG_ONLY_US = ' is only available to US residents.';
export const MSG_ONLY_FILTER = ' is only available for itineraries between $500 and $10,000';
export const MSG_AA_SHOWN = 'post adverse action';
export const MSG_ARIA_PM_SELECTED = 'Pay Monthly selected! Fill out the application form to check your loan rate!';
export const MSG_ARIA_PM_DESELECTED = 'Pay in full option selected!';

// K
export const K_UP = 'up';
export const K__UP = '_up';
export const K_LOG_UP = '>>> up:';
export const K_JQUERY = 'jQuery';
export const K_DISABLED = 'disabled';
export const K_CLICK = 'click';
export const K_CHANGE = 'change';
export const K_MESSAGE = 'message';
export const K_SESSION = 'session';
export const K_CHECKED = 'checked';
export const K_ARIA_CHECKED = 'aria-checked';
export const K_LOAD_FN = 'load-fn';
export const K_WATCH_FN = 'watch-fn';
export const K_CONTACT = 'contact';
export const K_STATUS = EV_STATUS;
export const K_ORDER_ID = EV_ORDER_ID;
export const K_BUILD = EV_BUILD;
export const K_CONTAINER = EL_CONTAINER;
export const K_FB_SCROLL_TARGET = 'fb-scroll-target';
export const K_ORIGIN = EV_ORIGIN;
export const K_VERSION = EV_VERSION;
export const K_ORDER_AMOUNT = EV_ORDER_AMOUNT;
export const K_CONFIRMATION_ID = 'confirmation_' + K_ID;
export const K_APR = 'apr';
export const K_PRICE = 'price';
export const K_SIGN = 'sign';
export const K_POST = EA_POST;
export const K_BODY = 'body';
export const K_HEAD = 'head';
export const K_HASHCHANGE = 'hashchange';
export const K_OK = 'ok';
export const K_FAIL = 'fail';
export const K_FATAL = 'fatal';
export const K_DATA = 'data';
export const K_COMMAND = 'command';
export const K_ARGS = 'args';
export const K_TOP = 'top';
export const K_LEVEL = 'level';
export const K_SILENT = 'silent';
export const K_INFO = 'info';
export const K_WARN = 'warn';
export const K_ERROR = 'error';
export const K_DEBUG = 'debug';
export const K_TRACE = 'trace';
export const K_SEND = 'send';
export const K_DEFAULT_EV = 'default_ev';
export const K_EVENT_TYPE = 'event_type';
export const K_CLIENT = 'client';
export const K_CLIENT_TOKEN = 'client';
export const K_BIN = '555237';
export const K_OFFERS = 'offers';
export const K_TRIP_TYPE = 'roundtrip';
export const K_TRAVELERS = 'travelers';
export const K_BORROWER = 'borrower';
export const K_BILLING_CONTACT = 'billing_contact';
export const K_CUSTOMER_ID = 'customer_' + K_ID;
export const K_CUSTOMER = 'customer';
export const K_UP_CODE = 'up_code';
export const K_UPCODE = 'upcode';
export const K_ERROR_MESSAGES = K_ERROR + '_messages';
export const K_TYPES = 'types';
export const K_API_HOST = 'api_host';
export const K_EC = 'eventCategory';
export const K_EA = 'eventAction';
export const K_EL = 'eventLabel';
export const K_EV = 'eventValue';
export const K_IFRAME = 'iframe';
export const K_CARD_NUMBER = 'card_number';
export const K_FIRST_NAME = 'first_name';
export const K_LAST_NAME = 'last_name';
export const K_DATE_OF_BIRTH = 'date_of_birth';
export const K_EMAIL = 'email';
export const K_PHONE = 'phone';
export const K_STREET_ADDRESS = 'street_address';
export const K_CITY = 'city';
export const K_REGION = 'region';
export const K_POSTAL_CODE = 'postal_code';
export const K_PAYLOAD = 'payload';
export const K_FRAMEBOSS = 'frameboss';
export const K_LOAN_OFFER = 'loan_offer';
export const K_MONTHLY_PAYMENT_AMOUNT = 'monthly_payment_amount';
export const K_SELECTORS = 'selectors';
export const K_PRICING = 'pricing';
export const K_PRICING_BASE = 'pricing_base';
export const K_PIXEL = 'pixel';
export const K_ENGINE = 'engine';
export const K_API_KEY = 'apiKey';
export const K_COUNTRY_CODE = 'country_code';

// ATTR
export const ATTR_PRICING = 'data-up-pricing';
export const ATTR_PRICING_BASE = 'data-up-pricing-base';

// Types
export const T_FN = 'function';
export const T_OBJ = 'object';
export const T_UNDEFINED = 'undefined';
export const T_STR = 'string';
export const T_ARRAY = 'Array';


// query selectors - pm
export const CLASS_PRICE_PILL = 'up-from-price-pill';
export const QS_MODAL = '#up-pm-modal';
export const QS_PRICE_TEXT = '.up-from-price';
export const QS_PAYMENT_OPTIONS = '#payment-options';
export const QS_FROM_PRICE = '#uplift-from-price';
export const QS_FROM_PRICING = '#up-pm-from-pricing';
export const QS_FULL_PRICE = '#uplift-full-price';
export const QS_PM_MESSAGE = '#up-pm-message';
export const QS_METHOD_PM = '#payment-method-pm';
export const QS_METHOD_CC = '#payment-method-cc';
export const QS_PM_CONTAINER = '#pay-monthly-container';
export const QS_PM_COMPLETE = '#pay-monthly-complete';
export const QS_PM_NOT_CONFIRMED = '#up-pm-not-confirmed';
export const QS_PM_ANNOUNCE = '#up-pm-announce';
export const QS_PM_PRICE_SUMMARY = '#up-pm-price-summary';
export const QS_PM_TOTAL_LINE = '#up-pm-total-line';
export const QS_PM_HEADER = '#uplift-header-branding';
export const QS_STYLE_PRICING = '#up-style-pricing';

// FB

export const FB_IFRAME_LOAD = 'iFrameLoad';
export const FB_IFRAME_READY = 'iFrameReady';
export const FB_ON_APPROVED = 'onApproved';
export const FB_ON_DENIED = 'onDenied';
export const FB_ON_REJECTED = 'onRejected';
export const FB_ON_REJECTED_CONTINUE = 'onRejectedContinue';
export const FB_ON_PAYMENT_READY = 'onPaymentReady';
export const FB_ON_PAYMENT_UNREADY = 'onPaymentUnready';
export const FB_ON_ERROR = 'onError';
export const FB_NEXT_FROM_TOP_FRAME = 'next-from-top-frame';
export const FB_PAUSE = 'pause';
export const FB_RESUME = 'resume';
export const FB_SEND_HEIGHT = 'send-height';
export const FB_SEND_CEVENT = 'send-cevent';
export const FB_HEIGHT = 'height';
export const FB_REAPPLY = 'reapply';
export const FB_ON_REAPPLY = 'onReapply';
export const FB_ON_REAPPLY_LOAD = 'onReapplyLoad';
export const FB_PERSIST_ORDER = 'persist-order';
export const FB_SCROLL = 'scroll';
export const FB_IS_CONFIRMED_RESPONSE = 'is-confirmed-response';
export const FB_ORDER_UPDATE = EL_ORDER_UPDATE;
export const FB_ORDER_CREATE = EL_ORDER_CREATE;
export const FB_PROCESSING_BEGIN = 'processing-begin';
export const FB_PROCESSING_END = 'processing-end';
export const FB_XHR_ERROR = 'xhr-error';
export const NEXT_SSN = '/ssn';
export const PAGE_PAY = 'pay';
export const PAGE_ACCEPT = 'accept';
export const FB_ON_PAYMENT_START = 'onPaymentStart';
export const FB_ON_PAYMENT_END = 'onPaymentEnd';
export const FB_ON_REAPPLY_CONTINUE = 'onReapplyContinue';
export const FB_ON_REAPPLY_MOUNT = 'onReapplyMount';

// poor man's templating vars
export const TPL_SIGN = '%%';
export const TPL_VAR_APR = TPL_SIGN + K_APR + TPL_SIGN;
export const TPL_VAR_PRICE = TPL_SIGN + K_PRICE + TPL_SIGN;
export const TPL_VAR_SIGN = TPL_SIGN + K_SIGN + TPL_SIGN;
export const TPL_UP_CODE = TPL_SIGN + K_UP_CODE + TPL_SIGN;
export const TPL_CID = TPL_SIGN + K_CUSTOMER_ID + TPL_SIGN;
export const TPL_ORDER_ID = TPL_SIGN + K_ORDER_ID + TPL_SIGN;
export const TPL_LIB_NAME = TPL_SIGN + 'lib_name' + TPL_SIGN;

// patterns
export const LIB_PREFIX = 'up.lib.js.';
export const PREFIX_PATTERN_WARN = LIB_PREFIX + TPL_LIB_NAME + '/warn: ';


// URLs
export const API_METHOD_MRKT_V1 = '/mrkt/v1/' + TPL_UP_CODE + '/' + TPL_CID + '/from';
export const API_METHOD_MRKT_V2 = '/marketing/v2/' + TPL_UP_CODE + '/' + TPL_CID + '/from';
export const API_METHOD_ORDERS = '/majikku/v2/orders';
export const API_METHOD_ERROR = '/majikku/v2/' + TPL_ORDER_ID + '/error';
export const API_METHOD_CONFIRMATION = '/majikku/v2/' + TPL_ORDER_ID + '/confirmation';
export const API_HOST_PRD = 'pay-api2.uplift.com';
export const API_HOST_DEV = 'localhost';
export const HTTP = 'http://';
export const HTTPS = 'https://';
export const IFRAME_HOST_STAGING = HTTPS + 'uplift-cdn-stg.uplift.com';
export const IFRAME_HOST_PRODUCTION = HTTPS + 'cdn.uplift.com';
export const IFRAME_PM_NAME = 'pay-monthly';
export const IFRAME_BUCKET_PATH = '/iframe/v3';
export const IFRAME_PM_INDEX = '/index.html';
export const PORT_2000 = ':2000';
export const PORT_6002 = ':6002';
export const PORT_6003 = ':6003';
export const PORT_6080 = ':6080';
export const HEADERS_XHR_DEFAULT = {'Content-type': 'application/json'};
export const API_KASA_API_HEADER = 'KASA-API-VERSION';

// Reasons for failed pm
export const REASON_NUMBER_OF_PAYMENTS = 'number of payments';
export const REASON_LOAN_DENIED = 'loan denied';
export const REASON_FAIL_PARSE_TRAV_DETAILS = 'unable to parse traveler details';
export const REASON_MISSING_TRAV_DETAILS = 'missing traveler details';
export const REASON_NOT_IN_COHORT = 'not in cohort';
